export type CommissionViewMode = "table" | "grid";

export const ALL_TYPE_FILTER_VALUE = "__all__";

export const COMMISSIONS_PAGE_GUIDE = [
  "Choisissez le type de commission avant de saisir la transaction.",
  "Le montant est toujours saisi manuellement, il n'y a pas de calcul automatique.",
];

export const COMMISSIONS_PAGE_TIP =
  "Une commission déjà enregistrée n'est pas modifiable directement, passez par une demande de modification.";
